
// import React, {
//   useEffect,
//   useState
// } from "react";

// import axios from "axios";

// import { API } from "../config";

// import "../../style/RectorPlaneaciones.css";

// export default function RectorPlaneaciones() {

//   const token = localStorage.getItem("token");

//   const headers = {
//     Authorization: `Bearer ${token}`
//   };

//   /* ======================================================
//      STATES
//   ====================================================== */

//   const [loading, setLoading] = useState(false);

//   const [planeaciones, setPlaneaciones] = useState([]);

//   const [
//     planeacionSeleccionada,
//     setPlaneacionSeleccionada
//   ] = useState(null);

//   const [unidades, setUnidades] = useState([]);

//   const [
//     filtroEstado,
//     setFiltroEstado
//   ] = useState("");

//   const [
//     filtroPeriodo,
//     setFiltroPeriodo
//   ] = useState("");

//   const [periodos, setPeriodos] = useState([]);

//   const [
//     comentario,
//     setComentario
//   ] = useState("");

//   /* ======================================================
//      CARGAR PERIODOS
//   ====================================================== */

//   const cargarPeriodos = async () => {

//     try {

//       const res = await axios.get(
//         `${API}/planeaciones/periodos`,
//         { headers }
//       );

//       setPeriodos(
//         res.data.periodos || []
//       );

//     } catch (error) {

//       console.error(error);

//     }

//   };

//   /* ======================================================
//      LISTAR PLANEACIONES
//   ====================================================== */

//   const listarPlaneaciones = async () => {

//     try {

//       setLoading(true);

//       const res = await axios.get(
//         `${API}/planeaciones`,
//         { headers }
//       );

//       let lista =
//         res.data.planeaciones || [];

//       /* =========================================
//          FILTRO ESTADO
//       ========================================= */

//       if (filtroEstado) {

//         lista = lista.filter(
//           (p) =>
//             p.estado === filtroEstado
//         );

//       }

//       /* =========================================
//          FILTRO PERIODO
//       ========================================= */

//       if (filtroPeriodo) {

//         lista = lista.filter(
//           (p) =>
//             String(p.periodo_id) ===
//             String(filtroPeriodo)
//         );

//       }

//       setPlaneaciones(lista);

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error cargando planeaciones"
//       );

//     } finally {

//       setLoading(false);

//     }

//   };

//   /* ======================================================
//      OBTENER PLANEACION
//   ====================================================== */

//   const obtenerPlaneacion = async (id) => {

//     try {

//       const res = await axios.get(
//         `${API}/planeaciones/${id}`,
//         { headers }
//       );

//       setPlaneacionSeleccionada(
//         res.data.planeacion
//       );

//       setUnidades(
//         res.data.unidades || []
//       );

//       setComentario(
//         res.data.planeacion
//           ?.comentario_revision || ""
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error obteniendo planeación"
//       );

//     }

//   };

//   /* ======================================================
//      APROBAR
//   ====================================================== */

//   const aprobarPlaneacion = async () => {

//     try {

//       if (!planeacionSeleccionada) {
//         return;
//       }

//       const ok = window.confirm(
//         "¿Aprobar esta planeación?"
//       );

//       if (!ok) return;

//       await axios.post(

//         `${API}/planeaciones/${planeacionSeleccionada.id}/aprobar`,

//         {
//           comentario
//         },

//         { headers }

//       );

//       alert(
//         "Planeación aprobada"
//       );

//       listarPlaneaciones();

//       obtenerPlaneacion(
//         planeacionSeleccionada.id
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error aprobando planeación"
//       );

//     }

//   };

//   /* ======================================================
//      RECHAZAR
//   ====================================================== */

//   const rechazarPlaneacion = async () => {

//     try {

//       if (!planeacionSeleccionada) {
//         return;
//       }

//       if (!comentario) {

//         return alert(
//           "Debe escribir observaciones"
//         );

//       }

//       const ok = window.confirm(
//         "¿Rechazar esta planeación?"
//       );

//       if (!ok) return;

//       await axios.post(

//         `${API}/planeaciones/${planeacionSeleccionada.id}/rechazar`,

//         {
//           comentario
//         },

//         { headers }

//       );

//       alert(
//         "Planeación rechazada"
//       );

//       listarPlaneaciones();

//       obtenerPlaneacion(
//         planeacionSeleccionada.id
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error rechazando planeación"
//       );

//     }

//   };

//   /* ======================================================
//      DESCARGAR PDF
//   ====================================================== */

//   const descargarPDF = async (id) => {

//     try {

//       const response = await axios.get(
//         `${API}/planeaciones/${id}/pdf`,
//         {
//           headers,
//           responseType: "blob"
//         }
//       );

//       const url = window.URL.createObjectURL(
//         new Blob([response.data])
//       );

//       const link =
//         document.createElement("a");

//       link.href = url;

//       link.setAttribute(
//         "download",
//         `planeacion_${id}.pdf`
//       );

//       document.body.appendChild(link);

//       link.click();

//       link.remove();

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error descargando PDF"
//       );

//     }

//   };

//   /* ======================================================
//      EFFECTS
//   ====================================================== */

//   useEffect(() => {

//     listarPlaneaciones();

//   }, [
//     filtroEstado,
//     filtroPeriodo
//   ]);

//   useEffect(() => {

//     cargarPeriodos();

//   }, []);

//   return (

//     <div className="rector-planeaciones-container">

//       {/* =========================================
//           SIDEBAR
//       ========================================= */}

//       <div className="rector-sidebar">

//         <div className="sidebar-top">

//           <h2>
//             Planeaciones
//           </h2>

//           {/* =====================================
//               FILTRO ESTADO
//           ===================================== */}

//           <select
//             value={filtroEstado}
//             onChange={(e) =>
//               setFiltroEstado(
//                 e.target.value
//               )
//             }
//           >

//             <option value="">
//               Todos los estados
//             </option>

//             <option value="BORRADOR">
//               Borrador
//             </option>

//             <option value="ENVIADA">
//               Enviadas
//             </option>

//             <option value="APROBADA">
//               Aprobadas
//             </option>

//             <option value="RECHAZADA">
//               Rechazadas
//             </option>

//           </select>

//           {/* =====================================
//               FILTRO PERIODO
//           ===================================== */}

//           <select
//             value={filtroPeriodo}
//             onChange={(e) =>
//               setFiltroPeriodo(
//                 e.target.value
//               )
//             }
//           >

//             <option value="">
//               Todos los periodos
//             </option>

//             {

//               periodos.map((p) => (

//                 <option
//                   key={p.id}
//                   value={p.id}
//                 >
//                   {p.nombre}
//                 </option>

//               ))

//             }

//           </select>

//         </div>

//         {

//           loading

//           ? (
//             <p>
//               Cargando...
//             </p>
//           )

//           : (

//             planeaciones.map((p) => (

//               <div
//                 key={p.id}
//                 className={`card-planeacion ${
//                   planeacionSeleccionada?.id === p.id
//                   ? "active"
//                   : ""
//                 }`}
//                 onClick={() =>
//                   obtenerPlaneacion(p.id)
//                 }
//               >

//                 <h4>
//                   {p.titulo}
//                 </h4>

//                 <p>
//                   {p.profesor}
//                 </p>

//                 <small>
//                   {p.asignatura || "Sin materia"}
//                 </small>

//                 <small>
//                   {
//                     p.grado_nombre ||
//                     p.grado ||
//                     "-"
//                   }
//                   {" - "}
//                   {
//                     p.grupo_nombre ||
//                     p.grupo ||
//                     "-"
//                   }
//                 </small>

//                 <span>
//                   {p.estado}
//                 </span>

//               </div>

//             ))

//           )

//         }

//       </div>

//       {/* =========================================
//           CONTENT
//       ========================================= */}

//       <div className="rector-content">

//         {

//           planeacionSeleccionada ? (

//             <>

//               {/* =====================================
//                   HEADER
//               ===================================== */}

//               <div className="detalle-header">

//                 <div>

//                   <h1>
//                     {
//                       planeacionSeleccionada.titulo
//                     }
//                   </h1>

//                   {/* =================================
//                       INFORMACION GENERAL
//                   ================================= */}

//                   <div className="info-planeacion">

//                     <div className="info-item">
//                       <strong>
//                         Profesor
//                       </strong>

//                       <span>
//                         {
//                           planeacionSeleccionada.profesor || "N/A"
//                         }
//                       </span>
//                     </div>

//                     <div className="info-item">
//                       <strong>
//                         Sede
//                       </strong>

//                       <span>
//                         {
//                           planeacionSeleccionada.sede || "N/A"
//                         }
//                       </span>
//                     </div>

//                     <div className="info-item">
//                       <strong>
//                         Materia
//                       </strong>

//                       <span>
//                         {
//                           planeacionSeleccionada.asignatura || "N/A"
//                         }
//                       </span>
//                     </div>

//                     <div className="info-item">
//                       <strong>
//                         Área
//                       </strong>

//                       <span>
//                         {
//                           planeacionSeleccionada.area ||
//                           planeacionSeleccionada.asignatura ||
//                           "N/A"
//                         }
//                       </span>
//                     </div>

//                     <div className="info-item">
//                       <strong>
//                         Año Lectivo
//                       </strong>

//                       <span>
//                         {
//                           planeacionSeleccionada.anio_lectivo || "N/A"
//                         }
//                       </span>
//                     </div>

//                     <div className="info-item">
//                       <strong>
//                         Periodo
//                       </strong>

//                       <span>
//                         {
//                           planeacionSeleccionada.periodo || "N/A"
//                         }
//                       </span>
//                     </div>

//                     <div className="info-item">
//                       <strong>
//                         Grado
//                       </strong>

//                       <span>
//                         {
//                           planeacionSeleccionada.grado_nombre ||
//                           planeacionSeleccionada.grado ||
//                           "N/A"
//                         }
//                       </span>
//                     </div>

//                     <div className="info-item">
//                       <strong>
//                         Grupo
//                       </strong>

//                       <span>
//                         {
//                           planeacionSeleccionada.grupo_nombre ||
//                           planeacionSeleccionada.grupo ||
//                           "N/A"
//                         }
//                       </span>
//                     </div>

//                     <div className="info-item">
//                       <strong>
//                         Estado
//                       </strong>

//                       <span
//                         className={`estado ${
//                           planeacionSeleccionada.estado
//                         }`}
//                       >
//                         {
//                           planeacionSeleccionada.estado || "N/A"
//                         }
//                       </span>
//                     </div>

//                   </div>

//                 </div>

//                 {/* =================================
//                     ACCIONES
//                 ================================= */}

//                 <div className="acciones">

//                   <button
//                     className="btn-pdf"
//                     onClick={() =>
//                       descargarPDF(
//                         planeacionSeleccionada.id
//                       )
//                     }
//                   >
//                     Descargar PDF
//                   </button>

//                   {

//                     planeacionSeleccionada.estado ===
//                     "ENVIADA" && (

//                       <>

//                         <button
//                           className="btn-aprobar"
//                           onClick={
//                             aprobarPlaneacion
//                           }
//                         >
//                           Aprobar
//                         </button>

//                         <button
//                           className="btn-rechazar"
//                           onClick={
//                             rechazarPlaneacion
//                           }
//                         >
//                           Rechazar
//                         </button>

//                       </>

//                     )

//                   }

//                 </div>

//               </div>

//               {/* =====================================
//                   OBSERVACIONES
//               ===================================== */}

//               <div className="comentario-container">

//                 <h3>
//                   Observaciones Rector / Coordinador
//                 </h3>

//                 <textarea
//                   className="comentario-box"
//                   placeholder="Escriba observaciones sobre la planeación..."
//                   value={comentario}
//                   onChange={(e) =>
//                     setComentario(
//                       e.target.value
//                     )
//                   }
//                 />

//               </div>

//               {/* =====================================
//                   UNIDADES
//               ===================================== */}

//               {

//                 unidades.length === 0 ? (

//                   <div className="empty-unidades">

//                     <h3>
//                       Esta planeación no tiene unidades registradas
//                     </h3>

//                   </div>

//                 ) : (

//                   unidades.map((u) => (

//                     <div
//                       key={u.id}
//                       className="unidad-card"
//                     >

//                       <div className="unidad-header">

//                         <h3>
//                           {u.unidad}
//                         </h3>

//                         <div className="semanas">

//                           <span>
//                             Semana Inicio:
//                             {" "}
//                             {u.semana_inicio || "-"}
//                           </span>

//                           <span>
//                             Semana Fin:
//                             {" "}
//                             {u.semana_fin || "-"}
//                           </span>

//                         </div>

//                       </div>

//                       <div className="unidad-grid">

//                         <div>
//                           <strong>
//                             Tema
//                           </strong>

//                           <p>
//                             {u.tema || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Competencia
//                           </strong>

//                           <p>
//                             {u.competencia || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             DBA
//                           </strong>

//                           <p>
//                             {u.dba || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Estándares
//                           </strong>

//                           <p>
//                             {u.estandares || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Desempeños
//                           </strong>

//                           <p>
//                             {u.desempenos || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Metodología
//                           </strong>

//                           <p>
//                             {u.metodologia || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Actividades
//                           </strong>

//                           <p>
//                             {u.actividades || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Recursos
//                           </strong>

//                           <p>
//                             {u.recursos || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Evidencias
//                           </strong>

//                           <p>
//                             {u.evidencias || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Evaluación
//                           </strong>

//                           <p>
//                             {u.evaluacion || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             PIAR
//                           </strong>

//                           <p>
//                             {u.piar || "-"}
//                           </p>
//                         </div>

//                         <div>
//                           <strong>
//                             Observaciones
//                           </strong>

//                           <p>
//                             {u.observaciones || "-"}
//                           </p>
//                         </div>

//                       </div>

//                     </div>

//                   ))

//                 )

//               }

//             </>

//           ) : (

//             <div className="empty-state">

//               <h2>
//                 Seleccione una planeación
//               </h2>

//             </div>

//           )

//         }

//       </div>

//     </div>

//   );

// }


import React, {
  useEffect,
  useState
} from "react";

import api from "../../api/axiosAuth";

import "../../style/RectorPlaneaciones.css";

export default function RectorPlaneaciones() {

  /* ======================================================
     STATES
  ====================================================== */

  const [loading, setLoading] = useState(false);

  const [planeaciones, setPlaneaciones] = useState([]);

  const [
    planeacionSeleccionada,
    setPlaneacionSeleccionada
  ] = useState(null);

  const [unidades, setUnidades] = useState([]);

  const [
    filtroEstado,
    setFiltroEstado
  ] = useState("");

  const [
    filtroPeriodo,
    setFiltroPeriodo
  ] = useState("");

  const [periodos, setPeriodos] = useState([]);

  const [
    comentario,
    setComentario
  ] = useState("");

  /* ======================================================
     CARGAR PERIODOS
  ====================================================== */

  const cargarPeriodos = async () => {

    try {

      const { data } = await api.get(
        "/planeaciones/periodos"
      );

      setPeriodos(
        Array.isArray(data?.periodos)
          ? data.periodos
          : Array.isArray(data)
          ? data
          : []
      );

    } catch (error) {

      console.error(
        "Error cargando periodos:",
        error
      );

      setPeriodos([]);

    }

  };

  /* ======================================================
     LISTAR PLANEACIONES
  ====================================================== */

  const listarPlaneaciones = async () => {

    try {

      setLoading(true);

      const { data } = await api.get(
        "/planeaciones"
      );

      let lista = Array.isArray(data?.planeaciones)
        ? data.planeaciones
        : Array.isArray(data)
        ? data
        : [];

      if (filtroEstado) {

        lista = lista.filter(
          (p) => p.estado === filtroEstado
        );

      }

      if (filtroPeriodo) {

        lista = lista.filter(
          (p) =>
            String(p.periodo_id) ===
            String(filtroPeriodo)
        );

      }

      setPlaneaciones(lista);

    } catch (error) {

      console.error(
        "Error cargando planeaciones:",
        error
      );

      setPlaneaciones([]);

      alert(
        "Error cargando planeaciones."
      );

    } finally {

      setLoading(false);

    }

  };

  /* ======================================================
     OBTENER PLANEACION
  ====================================================== */

  const obtenerPlaneacion = async (id) => {

    try {

      const { data } = await api.get(
        `/planeaciones/${id}`
      );

      setPlaneacionSeleccionada(
        data?.planeacion || null
      );

      setUnidades(
        Array.isArray(data?.unidades)
          ? data.unidades
          : []
      );

      setComentario(
        data?.planeacion?.comentario_revision || ""
      );

    } catch (error) {

      console.error(
        "Error obteniendo planeación:",
        error
      );

      alert(
        "Error obteniendo planeación."
      );

    }

  };

  /* ======================================================
     APROBAR
  ====================================================== */

  const aprobarPlaneacion = async () => {

    try {

      if (!planeacionSeleccionada)
        return;

      const ok = window.confirm(
        "¿Aprobar esta planeación?"
      );

      if (!ok) return;

      await api.post(

        `/planeaciones/${planeacionSeleccionada.id}/aprobar`,

        {
          comentario
        }

      );

      alert(
        "Planeación aprobada."
      );

      await listarPlaneaciones();

      await obtenerPlaneacion(
        planeacionSeleccionada.id
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error aprobando planeación."
      );

    }

  };

  /* ======================================================
     RECHAZAR
  ====================================================== */

  const rechazarPlaneacion = async () => {

    try {

      if (!planeacionSeleccionada)
        return;

      if (!comentario.trim()) {

        return alert(
          "Debe escribir observaciones."
        );

      }

      const ok = window.confirm(
        "¿Rechazar esta planeación?"
      );

      if (!ok) return;

      await api.post(

        `/planeaciones/${planeacionSeleccionada.id}/rechazar`,

        {
          comentario
        }

      );

      alert(
        "Planeación rechazada."
      );

      await listarPlaneaciones();

      await obtenerPlaneacion(
        planeacionSeleccionada.id
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error rechazando planeación."
      );

    }

  };

  /* ======================================================
     DESCARGAR PDF
  ====================================================== */

  const descargarPDF = async (id) => {

    try {

      const response = await api.get(

        `/planeaciones/${id}/pdf`,

        {
          responseType: "blob"
        }

      );

      const url = window.URL.createObjectURL(
        new Blob([response.data])
      );

      const link =
        document.createElement("a");

      link.href = url;

      link.download =
        `planeacion_${id}.pdf`;

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);

    } catch (error) {

      console.error(error);

      alert(
        "Error descargando PDF."
      );

    }

  };

  /* ======================================================
     EFFECTS
  ====================================================== */

  useEffect(() => {

    listarPlaneaciones();

  }, [
    filtroEstado,
    filtroPeriodo
  ]);

  useEffect(() => {

    cargarPeriodos();

  }, []);

    return (

    <div className="rector-planeaciones-container">

      {/* =========================================
          SIDEBAR
      ========================================= */}

      <div className="rector-sidebar">

        <div className="sidebar-top">

          <h2>
            Planeaciones
          </h2>

          {/* =====================================
              FILTRO ESTADO
          ===================================== */}

          <select
            value={filtroEstado}
            onChange={(e) =>
              setFiltroEstado(e.target.value)
            }
          >
            <option value="">
              Todos los estados
            </option>

            <option value="BORRADOR">
              Borrador
            </option>

            <option value="ENVIADA">
              Enviadas
            </option>

            <option value="APROBADA">
              Aprobadas
            </option>

            <option value="RECHAZADA">
              Rechazadas
            </option>

          </select>

          {/* =====================================
              FILTRO PERIODO
          ===================================== */}

          <select
            value={filtroPeriodo}
            onChange={(e) =>
              setFiltroPeriodo(e.target.value)
            }
          >

            <option value="">
              Todos los periodos
            </option>

            {periodos.map((p) => (

              <option
                key={p.id}
                value={p.id}
              >
                {p.nombre}
              </option>

            ))}

          </select>

        </div>

        {

          loading

          ? (

            <p>Cargando...</p>

          )

          : (

            planeaciones.map((p) => (

              <div
                key={p.id}
                className={`card-planeacion ${
                  planeacionSeleccionada?.id === p.id
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  obtenerPlaneacion(p.id)
                }
              >

                <h4>
                  {p.titulo}
                </h4>

                <p>
                  {p.profesor}
                </p>

                <small>
                  {p.asignatura || "Sin materia"}
                </small>

                <small>

                  {
                    p.grado_nombre ||
                    p.grado ||
                    "-"
                  }

                  {" - "}

                  {
                    p.grupo_nombre ||
                    p.grupo ||
                    "-"
                  }

                </small>

                <span
                  className={`estado ${p.estado}`}
                >
                  {p.estado}
                </span>

              </div>

            ))

          )

        }

      </div>

      {/* =========================================
          CONTENIDO
      ========================================= */}

      <div className="rector-content">

        {

          planeacionSeleccionada ? (

            <>

              {/* =====================================
                  HEADER
              ===================================== */}

              <div className="detalle-header">

                <div>

                  <h1>

                    {
                      planeacionSeleccionada.titulo
                    }

                  </h1>

                  <div className="info-planeacion">

                    <div className="info-item">

                      <strong>
                        Profesor
                      </strong>

                      <span>
                        {
                          planeacionSeleccionada.profesor ||
                          "N/A"
                        }
                      </span>

                    </div>

                    <div className="info-item">

                      <strong>
                        Sede
                      </strong>

                      <span>
                        {
                          planeacionSeleccionada.sede ||
                          "N/A"
                        }
                      </span>

                    </div>

                    <div className="info-item">

                      <strong>
                        Materia
                      </strong>

                      <span>
                        {
                          planeacionSeleccionada.asignatura ||
                          "N/A"
                        }
                      </span>

                    </div>

                    <div className="info-item">

                      <strong>
                        Área
                      </strong>

                      <span>

                        {
                          planeacionSeleccionada.area ||
                          planeacionSeleccionada.asignatura ||
                          "N/A"
                        }

                      </span>

                    </div>

                    <div className="info-item">

                      <strong>
                        Año Lectivo
                      </strong>

                      <span>

                        {
                          planeacionSeleccionada.anio_lectivo ||
                          "N/A"
                        }

                      </span>

                    </div>

                    <div className="info-item">

                      <strong>
                        Periodo
                      </strong>

                      <span>

                        {
                          planeacionSeleccionada.periodo ||
                          "N/A"
                        }

                      </span>

                    </div>

                    <div className="info-item">

                      <strong>
                        Grado
                      </strong>

                      <span>

                        {
                          planeacionSeleccionada.grado_nombre ||
                          planeacionSeleccionada.grado ||
                          "N/A"
                        }

                      </span>

                    </div>

                    <div className="info-item">

                      <strong>
                        Grupo
                      </strong>

                      <span>

                        {
                          planeacionSeleccionada.grupo_nombre ||
                          planeacionSeleccionada.grupo ||
                          "N/A"
                        }

                      </span>

                    </div>

                    <div className="info-item">

                      <strong>
                        Estado
                      </strong>

                      <span
                        className={`estado ${
                          planeacionSeleccionada.estado
                        }`}
                      >

                        {
                          planeacionSeleccionada.estado ||
                          "N/A"
                        }

                      </span>

                    </div>

                  </div>

                </div>

                <div className="acciones">

                  <button
                    className="btn-pdf"
                    onClick={() =>
                      descargarPDF(
                        planeacionSeleccionada.id
                      )
                    }
                  >
                    Descargar PDF
                  </button>

                  {

                    planeacionSeleccionada.estado ===
                    "ENVIADA" && (

                      <>

                        <button
                          className="btn-aprobar"
                          onClick={
                            aprobarPlaneacion
                          }
                        >
                          Aprobar
                        </button>

                        <button
                          className="btn-rechazar"
                          onClick={
                            rechazarPlaneacion
                          }
                        >
                          Rechazar
                        </button>

                      </>

                    )

                  }

                </div>

              </div>

              {/* =====================================
                  OBSERVACIONES
              ===================================== */}

              <div className="comentario-container">

                <h3>

                  Observaciones Rector / Coordinador

                </h3>

                <textarea
                  className="comentario-box"
                  placeholder="Escriba observaciones..."
                  value={comentario}
                  onChange={(e) =>
                    setComentario(
                      e.target.value
                    )
                  }
                />

              </div>

              {/* =====================================
                  UNIDADES
              ===================================== */}
                            {

                unidades.length === 0 ? (

                  <div className="empty-unidades">

                    <h3>
                      Esta planeación no tiene unidades registradas.
                    </h3>

                  </div>

                ) : (

                  unidades.map((u) => (

                    <div
                      key={u.id}
                      className="unidad-card"
                    >

                      <div className="unidad-header">

                        <h3>
                          {u.unidad}
                        </h3>

                        <div className="semanas">

                          <span>
                            Semana Inicio:
                            {" "}
                            {u.semana_inicio || "-"}
                          </span>

                          <span>
                            Semana Fin:
                            {" "}
                            {u.semana_fin || "-"}
                          </span>

                        </div>

                      </div>

                      <div className="unidad-grid">

                        <div>

                          <strong>
                            Tema
                          </strong>

                          <p>
                            {u.tema || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Competencia
                          </strong>

                          <p>
                            {u.competencia || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            DBA
                          </strong>

                          <p>
                            {u.dba || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Estándares
                          </strong>

                          <p>
                            {u.estandares || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Desempeños
                          </strong>

                          <p>
                            {u.desempenos || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Metodología
                          </strong>

                          <p>
                            {u.metodologia || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Actividades
                          </strong>

                          <p>
                            {u.actividades || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Recursos
                          </strong>

                          <p>
                            {u.recursos || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Evidencias
                          </strong>

                          <p>
                            {u.evidencias || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Evaluación
                          </strong>

                          <p>
                            {u.evaluacion || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            PIAR
                          </strong>

                          <p>
                            {u.piar || "-"}
                          </p>

                        </div>

                        <div>

                          <strong>
                            Observaciones
                          </strong>

                          <p>
                            {u.observaciones || "-"}
                          </p>

                        </div>

                      </div>

                    </div>

                  ))

                )

              }

            </>

          ) : (

            <div className="empty-state">

              <h2>
                Seleccione una planeación
              </h2>

              <p>
                Seleccione una planeación del panel izquierdo para visualizar todos sus detalles.
              </p>

            </div>

          )

        }

      </div>

    </div>

  );

}